export const termsTranslations = {
  title: 'Gebruiksvoorwaarden',
  lastUpdated: 'Laatst bijgewerkt: 7 maart 2024',
  sections: {
    introduction: {
      title: 'Inleiding',
      content:
        'Welkom bij BiteCritic! Deze gebruiksvoorwaarden regelen het gebruik van onze platform en diensten. Door het gebruik van BiteCritic, gaat u akkoord met deze voorwaarden in volle zin.',
    },
    userAgreement: {
      title: 'Gebruikersovereenkomst',
      content: 'Door een account te maken op BiteCritic, gaat u akkoord met:',
      items: [
        'Geef nauwkeurige en eerlijke informatie',
        'Houd de beveiliging van uw account in',
        'Neem verantwoordelijkheid voor alle activiteiten onder uw account',
        'Comply with all applicable laws and regulations',
      ],
    },
    content: {
      title: 'Inhoudsrichtlijnen',
      content: 'Wanneer u BiteCritic gebruikt, gaat u akkoord met:',
      items: [
        'Deel eerlijke en eerlijke beoordelingen',
        'Respect intellectuele eigendom',
        'Post geen schadelijke, beledigende of ongepast materiaal',
        'Neem niet deel aan spam of misleidende gedrag',
      ],
    },
    contentRights: {
      title: 'Inhoudsrechten en -bewaring',
      content: 'Met betrekking tot uw inhoud op BiteCritic:',
      items: [
        'U behoudt eigendom van uw inhoud, maar verleent ons een wereldwijde, niet-exclusieve, royaltyvrije licentie om uw inhoud te gebruiken, weer te geven, te verspreiden, te reproduceren, te wijzigen en afgeleide werken te maken in verband met de Service en voor promotionele en marketingdoeleinden van BiteCritic, inclusief maar niet beperkt tot weergave op onze website, app en platforms van derden zoals sociale media',
        'Wanneer u uw account verwijdert, worden uw persoonlijke gegevens geanonimiseerd, maar uw beoordelingen en andere bijgedragen inhoud kunnen worden behouden',
        'Inhoud zal verschijnen als geplaatst door "Anonieme Gebruiker" na accountverwijdering',
        'Voor volledige verwijdering van alle inhoud, moet u rechtstreeks contact met ons opnemen via hurricanesoftwaresolutions@gmail.com',
        'We kunnen geanonimiseerde beoordelingen blijven weergeven om de waarde van het platform voor alle gebruikers te behouden',
      ],
    },
    privacy: {
      title: 'Privacy en gegevens',
      content:
        'We nemen uw privacy serieus. Door BiteCritic te gebruiken, erkent u dat:',
      items: [
        'We verzamelen en verwerken uw gegevens zoals beschreven in onze Privacy Policy',
        'Uw openbare profiel en beoordelingen zijn zichtbaar voor andere gebruikers',
        'U kunt uw privacy instellingen aanpassen via uw account',
        'We gebruiken cookies en vergelijkbare technologieën',
      ],
    },
    community: {
      title: 'Communityrichtlijnen',
      content: 'Als lid van de BiteCritic-community, gaat u akkoord met:',
      items: [
        'Behandel andere gebruikers met respect',
        'Neem niet deel aan belediging of discriminatie',
        'Geef constructieve en nuttige bijdragen',
        'Rapporteer ongepast materiaal of gedrag',
      ],
    },
    termination: {
      title: 'Account beëindigen',
      content: 'We behouden het recht om:',
      items: [
        'Account te stoppen of te beëindigen die deze voorwaarden overtreden',
        'Inhoud te verwijderen die onze richtlijnen overtreft',
        'Diensten aan te passen of te beëindigen met voldoende waarschuwing',
        'Gebruikersgegevens te anonimiseren maar inhoud te behouden bij accountverwijdering',
        'Verzoeken voor volledige verwijdering via e-mail binnen 30 dagen te verwerken',
      ],
    },
  },
  agreement: {
    checkbox:
      'Ik heb de gebruiksvoorwaarden gelezen en ga akkoord met deze voorwaarden',
    required:
      'U moet akkoord gaan met de gebruiksvoorwaarden om verder te gaan',
    view: 'Bekijk gebruiksvoorwaarden',
  },
} as const;

export default termsTranslations;
